import numeral from 'numeral';

// ----------------------------------------------------------------------

// eslint-disable-next-line import/no-named-as-default-member
numeral.register('locale', 'de', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'ème';
  },
  currency: {
    symbol: '€',
  },
});

// switch between locales
// eslint-disable-next-line import/no-named-as-default-member
numeral.locale('de');
const defaultLocal = 'de-DE';

export function fNumber(number: string | number) {
  return numeral(number).format('0.00');
}

export function fCurrency(number: string | number = 0) {
  const format = numeral(number).format('0,000.00');

  return result(format, '.00');
}

export function fToCurrency(number: string | number = 0, currency = 'EUR') {
  return number.toLocaleString('de-DE', {
    style: 'currency',
    currency: currency,
  });
}

export function fPercent(number: string | number) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number: string | number) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number: string | number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format: string, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

export function fToLocalNumber(number: string | number, locale = defaultLocal) {
  return number.toLocaleString(locale);
}

/**
 * Converts comma-formatted string to number for submission.
 * Example: "14,3" → 14.3
 */
export function parseLocalizedNumber(value: string): number {
  const normalizedValue = value.replace(/,/g, '.');
  return parseFloat(normalizedValue) || 0;
}

/**
 * Formats number/float for input display with comma as decimal separator.
 * Example: 14.3 → "14,3"
 */
export function formatNumberForInput(
  value: number | string | undefined | null,
): string {
  if (value === undefined || value === null || value === '') return '';
  if (typeof value === 'string') {
    // If it's already a string, try to parse and format it
    const num = parseFloat(value.replace(/,/g, '.'));
    if (Number.isNaN(num)) return value;
    return fToLocalNumber(num);
  }
  return fToLocalNumber(value);
}

/**
 * Normalizes user input by converting periods to commas.
 * Example: "14.3" → "14,3"
 */
export function normalizeDecimalInput(value: string): string {
  return value.replace(/\./g, ',');
}
